import React from "react";
import { Star } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

/**
 * ReviewCard — testimonial card used in the home page reviews carousel and
 * inside the venue's Reviews tab.
 */
export default function ReviewCard({ review }) {
  const { lang } = useLanguage();
  const isAr = lang === "ar";
  const author = review.author_name || (isAr ? "زبون" : "Customer");
  const rating = review.rating || 5;
  const comment = (review.comment && (review.comment[isAr ? "ar" : "en"] || review.comment.en || review.comment.ar)) || review.text || "";
  const city = review.city || review.area || "";
  const date = review.created_at ? new Date(review.created_at).toLocaleDateString(isAr ? "ar-QA" : "en-GB", { year: "numeric", month: "short" }) : "";

  return (
    <article className="mp-card-flat p-5 h-full flex flex-col" data-testid="mp-review-card">
      <div className="mp-stars mb-2">
        {Array.from({ length: 5 }).map((_, i) => (
          <Star key={i} size={14} fill={i < rating ? "currentColor" : "none"} stroke="currentColor" strokeWidth={1.5} />
        ))}
      </div>
      <p className="text-sm leading-relaxed text-[var(--mp-ink)] line-clamp-5 flex-1">
        “{comment || (isAr ? "تجربة رائعة." : "Great experience.")}”
      </p>
      <div className="mt-3 pt-3 border-t border-[var(--mp-border)] flex items-center justify-between">
        <div>
          <div className="text-xs font-bold text-[var(--mp-black)]">{author}</div>
          {city && <div className="text-[11px] text-[var(--mp-ink-muted)]">{city}</div>}
        </div>
        {date && <div className="text-[11px] text-[var(--mp-ink-soft)]">{date}</div>}
      </div>
    </article>
  );
}
